//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";

export default {
  name: "InvoiceLookup",
  components: {},
  data: function() {
    return {
      windowWidth: null,
      searchingInvoice: false,
      localError: "",
      selected: {
        invoiceNumber: "",
        orderNumber: ""
      }
    };
  },
  computed: {
    ...mapGetters(["config", "loading", "invoices", "invoiceError"]),
    errorMessage() {
      if (this.localError.length > 0) {
        return this.localError;
      } else {
        return this.invoiceError;
      }
    },
    totalDue() {
      let val = 0;
      this.invoices.forEach(el => {
        val += el.balance;
      });
      let dollarVal = val.toFixed(2);
      return `$${dollarVal}`;
    }
  },
  methods: {
    ...mapActions(["fetchInvoice"]),
    search() {
      if (this.searchingInvoice) return;
      this.localError = "";
      let _existing = this.invoices.find(
        el =>
          el.invoiceNumber === this.selected.invoiceNumber.trim() &&
          el.orderNumber === this.selected.orderNumber.trim()
      );
      if (this.selected["invoiceNumber"] === "" || _existing !== undefined) {
        if (_existing !== undefined) {
          this.localError = "Invoice already added!";
        }
      } else {
        this.searchingInvoice = true;
        this.fetchInvoice({
          payload: `${this.$root.api}/Invoice/FetchInvoice`,
          data: JSON.parse(JSON.stringify(this.selected))
        }).then(() => {
          Object.keys(this.selected).forEach(key => {
            this.selected[key] = "";
          });
          this.searchingInvoice = false;
        });
      }
    },
    proceedToPayment() {
      if (this.invoices.length === 0) return;
      this.localError = "";
      this.$emit("proceedToPayment");
    },
    removeRow(index) {
      this.invoices.splice(index, 1);
    },
    displayValue(row, col) {
      let val = row[col.key];
      if (col.type === "currency") {
        return `$${val}`;
      } else {
        return val;
      }
    }
  }
};
